import React from 'react';
import './SwitchBar.scss';

const SwitchBar = props => {
  const { categoryName, categoryType, dittoEnable, redisCommonData, dittoFunc, dataLocale } = props;
  const dittoConfig = redisCommonData.DITTO_CONFIG && JSON.parse(redisCommonData.DITTO_CONFIG);
  const { VIEW_FRAMES, VIEW_3D_TRY_ON } = dataLocale;
  return dittoConfig &&
    dittoConfig.isDittoEnableGlobal === 'ON' &&
    categoryType !== 'Accessories' &&
    categoryType !== 'Contact Lens' &&
    categoryName !== 'Reading Eyeglasses' ? (
    <div className="col-sm-8 isWebCamElement">
      <div className="main-switch">
        <span
          className={!dittoEnable ? 'green-color' : ''}
          onClick={dittoEnable ? dittoFunc : null}
        >
          {VIEW_FRAMES}
        </span>
        <div className="switch-lk">
          <input
            readOnly
            checked={dittoEnable}
            className="cmn-toggle cmn-toggle-round"
            id="cmn-toggle-1"
            type="checkbox"
            onClick={dittoFunc}
          />
          <label htmlFor="cmn-toggle-1"></label>
        </div>
        <span
          className={dittoEnable ? 'green-color' : ''}
          onClick={!dittoEnable ? dittoFunc : null}
        >
          {VIEW_3D_TRY_ON}
        </span>
      </div>
    </div>
  ) : (
    ''
  );
};

export default SwitchBar;
